import '../EquityNotification.scss';
import './CashOutNotification.scss';
import {EquityNotification} from "../EquityNotification";

export class CashOutNotification extends EquityNotification {
    static instance = ({
        template: require('./CashOutNotification.html'),
        controller: ['$scope', '$location', CashOutNotification],
        bindings: {
            notification: '<'
        }
    });
}